import { Title } from '@angular/platform-browser';
import { Component, ElementRef, ViewChild, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HostListener } from '@angular/core';

import { AuthDataService } from '@app/auth';
import { AuthQuery } from '@app/auth/auth.query';
import { SettingsService } from '@app/services/settings.service';

import { environment } from './../../environments/environment';
import { Logger } from '@core';
import { roleBadgeClasses as getRoleBadgeClasses, roleBadgeLabel } from '@app/@shared/roles';

import { JournalService, MailService, Mail } from '@core';

@Component({
  selector: 'app-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.scss'],
})
export class ShellComponent implements OnInit {
  events: string[] = [];
  opened: boolean;
  appropriateClass: string = '';

  isEmptyNotification = true;

  // Per-feature visibility flags (granular)
  showZahlungsabgleich = environment.showZahlungsabgleich;
  showHelp = environment.showHelp;
  showDienstnehmer = environment.showDienstnehmer;
  showBulkImport = environment.showBulkImport;

  imageStorage = environment.serverUrl + '/'; // images gehen über api

  @HostListener('window:resize', ['$event'])
  getScreenHeight() {
    //console.log(window.innerHeight);
    if (window.innerHeight <= 412) {
      this.appropriateClass = 'bottomRelative';
    } else {
      this.appropriateClass = 'bottomStick';
    }
  }

  constructor(
    private router: Router,
    private titleService: Title,
    private authService: AuthDataService,
    private authQuery: AuthQuery,
    private journalService: JournalService,
    private settingsService: SettingsService
  ) {
    //this.getScreenHeight();
  }

  ngOnInit() {
    this.settingsService.getDemoMode().subscribe(
      (response) => {
        if (response?.result === 1) {
          this.authService.updateDemoMode(response.demo_mode);
        }
      },
      () => {}
    );
  }

  logout() {
    this.authService.logout().subscribe(() => {
      //this.router.navigate(['/login'], { replaceUrl: true });
      // changes mario: 25.3.24
      //probably better: this.router.navigateByUrl('/login');

      // Alternatively, for a hard reset, you might want to reload the entire application
      window.location.href = '/login';
    });
    console.log('logout');
    this.journalService.log('Abmeldung Logout erfolgreich', '', '');
  }

  get role(): number | null {
    return this.authQuery.role;
  }

  get roleName(): string {
    const roleId = Number(this.role);
    if (roleId) {
      return roleBadgeLabel(roleId);
    }
    return this.authQuery.roleName || 'Unbekannt';
  }

  get roleBadgeClasses(): string {
    return getRoleBadgeClasses(Number(this.role));
  }

  // ---------------------------------------------------------------
  // Role helpers / role-aware navigation visibility
  //   Admin    (1/2): everything
  //   Editor   (6)  : Transfer, Mandate, VSTV, Zahlung, Reports (no admin tools)
  //   Erfasser (4)  : Ueberblick, Transfer, Bulk-Import (no Mandate/VSTV/Zahlung)
  // ---------------------------------------------------------------
  get isAdmin(): boolean {
    return this.authQuery.isAdmin;
  }

  get isSuperuser(): boolean {
    return this.authQuery.isSuperuser;
  }

  get isEditor(): boolean {
    return this.authQuery.isEditor;
  }

  get isErfasser(): boolean {
    return this.authQuery.isErfasser;
  }

  // Visible for everyone who can enter the app
  get canSeeDashboard(): boolean {
    return this.isAdmin || this.isEditor || this.isErfasser || this.authQuery.can('transfer');
  }

  get canSeeTransfer(): boolean {
    return this.authQuery.can('transfer');
  }

  get canSeeBulkImport(): boolean {
    return this.showBulkImport && this.authQuery.can('bulk-import');
  }

  get canSeeMandate(): boolean {
    return this.authQuery.can('mandate');
  }

  get canSeeVstv(): boolean {
    return this.authQuery.can('vstv');
  }

  get canSeeZahlung(): boolean {
    return this.showZahlungsabgleich && this.authQuery.can('zahlungsabgleich');
  }

  get canSeeReports(): boolean {
    return this.authQuery.can('reports');
  }

  // Admin-only tooling
  get canSeeSettings(): boolean {
    return this.isAdmin;
  }

  get canSeeDienstnehmer(): boolean {
    // Dienstnehmer is superuser-only, never for regular admins,
    // even when enabled via environment.showDienstnehmer.
    return this.showDienstnehmer && this.isSuperuser;
  }

  get username(): string | null {
    return this.authQuery.name;
  }

  get profile_image(): string | null {
    return this.authQuery.profile_image;
  }

  get email(): string | null {
    return this.authQuery.email;
  }

  get werbungActive(): boolean | false {
    return false;
  }

  /* handle dropdown by click */
  isDropdownOpen = false;
  @ViewChild('dropdownMenu') dropdownMenu!: ElementRef;
  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }
  /**--- */

  onSideNavOpened() {
    //  do something
  }

  get isMobile(): boolean {
    //return this.media.isActive('xs') || this.media.isActive('sm');
    return false;
  }

  get title(): string {
    return this.titleService.getTitle();
  }
}
